import React from "react";
import { useTranslation } from "react-i18next";

import { PickupRequestListItem } from "../../../../types";

import TwoLineGridCell from "../TwoLineGridCell";

interface Props {
  data: PickupRequestListItem;
}

// Collector view: the source company is always the caller, so only the hauler (target company)
// is worth a column, on a single line - unlike the portal's two-line ParticipantsGridCell.
const HaulerCompanyGridCell = ({ data }: Props) => {
  const { t } = useTranslation();

  if (!data.targetCompanyName) {
    return (
      <TwoLineGridCell
        firstLineData={t("pickupRequests.grid.awaitingAssignment")}
      />
    );
  }

  return (
    <TwoLineGridCell
      firstLineData={data.targetCompanyName}
      secondLineData={data.targetCompanyRegNumber}
    />
  );
};

export default HaulerCompanyGridCell;
